import React from 'react';
import { useTranslation } from 'react-i18next';

type CodeFieldProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  /** 誤りの文の要素の id（aria-describedby）。誤りが無ければ undefined。 */
  errorId?: string;
  disabled?: boolean;
};

/**
 * 6桁のコードの欄（メールのコード・認証アプリのコード）。
 *
 * 既存のパスワード再設定（resetPassword.tsx）は1桁ずつ6つの枠に分けているが、ここは1つの欄にした。
 * 認証アプリのコードは貼り付けて入れることが多く、ブラウザ・OS の「ワンタイムコードの入力の候補」
 * （autocomplete="one-time-code"）も1つの欄にしか入らないため。数字以外は落とし、6桁で止める。
 */
const CodeField: React.FC<CodeFieldProps> = ({ id, value, onChange, errorId, disabled }) => {
  const { t } = useTranslation('login');
  return (
    <div className="w-full">
      <label htmlFor={id} className="block mb-2 text-sm font-regular text-neutral/100">
        {t('mfa.code')}
      </label>
      <input
        id={id}
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        className="w-full border border-neutral/50 text-neutral/300 focus:outline-none focus:border-neutral/75 text-h5 tracking-[0.5em] placeholder:tracking-normal placeholder:text-body-2 rounded-md h-14 pl-4 pr-4"
        placeholder={t('mfa.code-holder')}
        value={value}
        disabled={disabled}
        aria-invalid={errorId ? true : undefined}
        aria-describedby={errorId}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
      />
    </div>
  );
};

export default CodeField;
